import axios from 'axios';

let Connexion : any = {};
Connexion.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/login`, data)
}

export default Connexion;